import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const usePathname = () => {
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    // Additional logic can be added here if needed
  }, [pathname]);

  return pathname;
};
